/* ==========================================================================
   FORMARE — PDP behaviours (custom elements, no dependencies)
   <fm-product> <fm-gallery> <fm-clip> <fm-slider> <fm-compare> <fm-sticky>
   커스텀 엘리먼트라서 테마 에디터에서 섹션이 다시 로드돼도 자동 재초기화됩니다.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__formareLoaded) return;
  window.__formareLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var finePointer = function () { return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches); };

  /* ---- shared observer: play clips only while mostly visible ---- */
  var clipIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.5) el.autoPlay(); else el.autoPause();
    });
  }, { threshold: [0, 0.5, 0.75] }) : null;

  /* ===================================================================
     <fm-clip> — autoplay-on-view muted loop, tap to pause, optional sound
     =================================================================== */
  class FmClip extends HTMLElement {
    connectedCallback() {
      this.v = this.querySelector('video');
      if (!this.v) return;
      this.userPaused = false;
      this.v.muted = true; this.v.loop = true; this.v.playsInline = true;
      var self = this;
      this.toggleBtn = this.querySelector('[data-fm-toggle]');
      this.soundBtn = this.querySelector('[data-fm-sound]');
      if (this.toggleBtn) this.toggleBtn.addEventListener('click', function () {
        if (self.v.paused) { self.userPaused = false; self.userStarted = true; self.play(); }
        else { self.userPaused = true; self.pause(); }
      });
      if (this.soundBtn) this.soundBtn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var willUnmute = self.v.muted;
        qa('fm-clip').forEach(function (c) { c.mute(); });
        if (willUnmute) { self.v.muted = false; self.classList.add('is-sound'); self.soundBtn.setAttribute('aria-pressed', 'true'); if (self.v.paused) { self.userPaused = false; self.play(); } }
      });
      this.v.addEventListener('playing', function () { self.classList.add('is-playing'); });
      this.v.addEventListener('pause', function () { self.classList.remove('is-playing'); });
      if (clipIO) clipIO.observe(this);
    }
    disconnectedCallback() { if (clipIO) clipIO.unobserve(this); }
    play() { var p = this.v.play(); if (p && p.catch) p.catch(function () {}); }
    pause() { this.v.pause(); }
    mute() { if (!this.v) return; this.v.muted = true; this.classList.remove('is-sound'); if (this.soundBtn) this.soundBtn.setAttribute('aria-pressed', 'false'); }
    autoPlay() { if (this.userPaused) return; if (reduce && !this.userStarted) return; this.play(); }
    autoPause() { this.pause(); if (!this.v.muted) this.mute(); }
  }

  /* ===================================================================
     <fm-slider> — scroll-snap track with prev / next buttons
     =================================================================== */
  class FmSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fm-track]');
      this.prev = this.querySelector('[data-fm-prev]');
      this.next = this.querySelector('[data-fm-next]');
      if (!this.track) return;
      var self = this;
      this.items = qa('[data-fm-item]', this.track);
      // reviews & wear-test videos: one card per view on phones, with a dot per card between the arrows
      if (this.classList.contains('fm-rev__slider') || this.classList.contains('fm-size__slider') || this.querySelector('.fm-ugc__who, .fm-ugc__quote')) this.classList.add('fm-slider--one');
      if (this.classList.contains('fm-slider--one') && this.items.length > 1 && this.next && !this.querySelector('.fm-slider__dots')) {
        var dots = document.createElement('div'); dots.className = 'fm-slider__dots';
        this.items.forEach(function (it, i) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (i + 1) + ' / ' + self.items.length);
          b.addEventListener('click', function () { self.goTo(i); });
          dots.appendChild(b);
        });
        this.next.parentNode.insertBefore(dots, this.next);
        this.dots = qa('button', dots);
      }
      var upd = function () { self.update(); };
      this.track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      this._upd = upd;
      if (this.prev) this.prev.addEventListener('click', function () { self.go(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.go(1); });
      // slider inside a closed accordion (size guide) has no width until opened → re-measure when it opens
      var acc = this.closest('details');
      if (acc) acc.addEventListener('toggle', function () { if (acc.open) requestAnimationFrame(upd); });
      this.update();
    }
    disconnectedCallback() { if (this._upd) window.removeEventListener('resize', this._upd); }
    step() {
      var it = this.items;
      if (it && it.length > 1) return Math.abs(it[1].offsetLeft - it[0].offsetLeft) || it[0].getBoundingClientRect().width;
      return this.track.clientWidth * 0.8;
    }
    go(dir) {
      var rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({ left: dir * this.step() * (rtl ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
    }
    goTo(i) {
      var rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollTo({ left: i * this.step() * (rtl ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
    }
    update() {
      var t = this.track, max = t.scrollWidth - t.clientWidth - 2, x = Math.abs(t.scrollLeft);
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max;
      if (this.dots) {
        var n = this.dots.length, i = x >= max ? n - 1 : Math.min(n - 1, Math.round(x / this.step()));
        this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
    }
  }

  /* ===================================================================
     <fm-compare> — before / after slider (native range input overlay)
     =================================================================== */
  class FmCompare extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('input[type=range]');
      if (!this.range) return;
      var self = this;
      var start = parseFloat(this.range.value) || 50;
      this.set(start);
      this.range.addEventListener('input', function () { self.stopHint = true; self.set(self.range.value); });
      if (!reduce && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { self.io.disconnect(); self.hint(start); }
        }, { threshold: 0.6 });
        this.io.observe(this);
      }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    set(v) { this.style.setProperty('--pos', v + '%'); this.range.value = v; }
    hint(start) {
      var self = this, t0 = null, dur = 1400;
      var path = function (p) { return start + Math.sin(p * Math.PI * 2) * 14 * (1 - p); };
      (function frame(ts) {
        if (self.stopHint) return;
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        self.set(Math.round(path(p) * 10) / 10);
        if (p < 1) requestAnimationFrame(frame); else self.set(start);
      })(performance.now());
    }
  }

  /* ===================================================================
     <fm-gallery> — snap track + thumbnails + counter
     =================================================================== */
  class FmGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fm-gtrack]');
      if (!this.track) return;
      this.slides = qa('[data-media-id]', this.track);
      this.thumbs = qa('[data-fm-thumb]', this);
      this.count = this.querySelector('[data-fm-count]');
      var self = this;
      this.thumbs.forEach(function (b, i) { b.addEventListener('click', function () { self.goTo(i); }); });
      var prev = this.querySelector('[data-fm-gprev]'), next = this.querySelector('[data-fm-gnext]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
      var tick;
      this.track.addEventListener('scroll', function () { clearTimeout(tick); tick = setTimeout(function () { self.sync(); }, 60); }, { passive: true });
      this.index = 0; this.sync();
      this.initZoom();
    }
    goTo(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      var s = this.slides[i]; if (!s) return;
      this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    /* ---- lightbox: pinch / double-tap / wheel zoom, drag to pan ---- */
    initZoom() {
      if (this.dataset.zoom !== 'true') return;
      var self = this;
      this.zoomList = [];
      this.slides.forEach(function (s, i) {
        if (!s.dataset.zoomSrc) return;
        self.zoomList.push(i);
        var img = s.querySelector('img');
        if (img) img.addEventListener('click', function () { self.openLb(i); });
      });
      var btn = this.querySelector('[data-fm-zoom]');
      if (btn) {
        btn.addEventListener('click', function () { self.openLb(self.zoomList.indexOf(self.index) > -1 ? self.index : self.zoomList[0]); });
        if (!this.zoomList.length) btn.hidden = true;
      }
    }
    buildLb() {
      var self = this, svg = function (d) { return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
      var d = document.createElement('dialog'); d.className = 'fm-lb'; d.setAttribute('aria-label', 'Image viewer');
      d.innerHTML = '<div class="fm-lb__stage" data-lb-stage><img class="fm-lb__img" data-lb-img alt="" draggable="false"></div>' +
        '<div class="fm-lb__top"><span class="fm-lb__count" data-lb-count aria-live="polite"></span>' +
        '<button type="button" class="fm-lb__btn" data-lb-close aria-label="Close">' + svg('<path d="M6 6l12 12M18 6 6 18"/>') + '</button></div>' +
        '<p class="fm-lb__hint" data-lb-hint aria-hidden="true"></p>' +
        '<div class="fm-lb__bar">' +
          '<button type="button" class="fm-lb__btn" data-lb-prev aria-label="Previous image">' + svg('<path d="M15 5 8 12l7 7"/>') + '</button>' +
          '<button type="button" class="fm-lb__btn" data-lb-out aria-label="Zoom out">' + svg('<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5M8.5 11h5"/>') + '</button>' +
          '<button type="button" class="fm-lb__btn" data-lb-in aria-label="Zoom in">' + svg('<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5M11 8.5v5M8.5 11h5"/>') + '</button>' +
          '<button type="button" class="fm-lb__btn" data-lb-next aria-label="Next image">' + svg('<path d="m9 5 7 7-7 7"/>') + '</button>' +
        '</div>';
      this.appendChild(d);
      this.lb = d; this.lbImg = d.querySelector('[data-lb-img]'); this.lbStage = d.querySelector('[data-lb-stage]');
      this.lbCount = d.querySelector('[data-lb-count]'); this.lbHintEl = d.querySelector('[data-lb-hint]');
      this.lbIn = d.querySelector('[data-lb-in]'); this.lbOut = d.querySelector('[data-lb-out]');
      this.z = { s: 1, x: 0, y: 0 };
      var stage = this.lbStage, img = this.lbImg, z = this.z;
      d.querySelector('[data-lb-close]').addEventListener('click', function () { self.closeLb(); });
      d.querySelector('[data-lb-prev]').addEventListener('click', function () { self.lbStep(-1); });
      d.querySelector('[data-lb-next]').addEventListener('click', function () { self.lbStep(1); });
      this.lbIn.addEventListener('click', function () { self.lbHint(false); self.lbZoomTo(z.s * 1.75, self.lbCenter(), true); });
      this.lbOut.addEventListener('click', function () { self.lbHint(false); var s = z.s / 1.75; self.lbZoomTo(s < 1.15 ? 1 : s, self.lbCenter(), true); });
      d.addEventListener('close', function () {
        document.documentElement.style.overflow = self.prevOverflow || '';
        window.removeEventListener('resize', self.lbOnResize);
        var s = self.slides[self.zoomList[self.lbPos]]; if (s) self.goTo(self.slides.indexOf(s));
      });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' && z.s <= 1.01) { e.preventDefault(); self.lbStep(-1); }
        else if (e.key === 'ArrowRight' && z.s <= 1.01) { e.preventDefault(); self.lbStep(1); }
        else if (e.key === '+' || e.key === '=') { e.preventDefault(); self.lbIn.click(); }
        else if (e.key === '-') { e.preventDefault(); self.lbOut.click(); }
        else if (e.key === '0') { e.preventDefault(); self.lbZoomTo(1, null, true); }
      });
      d.addEventListener('gesturestart', function (e) { e.preventDefault(); }); // iOS: no page zoom behind
      img.addEventListener('load', function () { self.lbApply(false); });
      this.lbOnResize = function () { self.lbApply(false); };

      // pointer gestures: 1 finger/mouse = pan (zoomed) or swipe (not zoomed); 2 fingers = pinch
      var pts = new Map(), g = null, lastTap = 0, lastXY = null, tapT = null;
      var snap = function (onImg, moved) {
        var a = Array.from(pts.values());
        if (a.length >= 2) {
          var m = self.lbRel((a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2);
          return { type: 'pinch', d0: Math.max(1, Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y)), m0: m, s0: z.s, zx: z.x, zy: z.y };
        }
        if (a.length === 1) return { type: 'pan', x0: a[0].x, y0: a[0].y, zx: z.x, zy: z.y, moved: !!moved, onImg: onImg };
        return null;
      };
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        self.lbHint(false);
        g = snap(e.target === img, pts.size > 1);
      });
      stage.addEventListener('pointermove', function (e) {
        if (!pts.has(e.pointerId) || !g) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (g.type === 'pinch' && pts.size >= 2) {
          var a = Array.from(pts.values());
          var dist = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
          var m = self.lbRel((a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2);
          var s = Math.max(1, Math.min(self.lbMax(), g.s0 * dist / g.d0));
          z.x = m.x - (g.m0.x - g.zx) * s / g.s0; z.y = m.y - (g.m0.y - g.zy) * s / g.s0; z.s = s;
          self.lbApply(false);
        } else if (g.type === 'pan') {
          var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
          if (Math.abs(dx) + Math.abs(dy) > 8) g.moved = true;
          if (z.s > 1.01) { z.x = g.zx + dx; z.y = g.zy + dy; self.lbApply(false); }
        }
      });
      var end = function (e) {
        if (!pts.has(e.pointerId)) return;
        pts.delete(e.pointerId);
        if (g && g.type === 'pan' && pts.size === 0 && e.type === 'pointerup') {
          var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
          if (!g.moved) {
            var q = self.lbRel(e.clientX, e.clientY);
            if (e.pointerType === 'mouse') {
              if (z.s > 1.01) self.lbZoomTo(1, null, true);
              else if (g.onImg) self.lbZoomTo(2.5, q, true);
              else self.closeLb();
            } else {
              var now = Date.now();
              if (now - lastTap < 320 && lastXY && Math.hypot(e.clientX - lastXY.x, e.clientY - lastXY.y) < 40) {
                clearTimeout(tapT); lastTap = 0;
                if (z.s > 1.01) self.lbZoomTo(1, null, true); else self.lbZoomTo(2.5, q, true);
              } else {
                lastTap = now; lastXY = { x: e.clientX, y: e.clientY };
                clearTimeout(tapT);
                if (!g.onImg && z.s <= 1.01) tapT = setTimeout(function () { self.closeLb(); }, 330);
              }
            }
          } else if (z.s <= 1.01) {
            if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) self.lbStep(dx < 0 ? 1 : -1);
            else if (e.pointerType !== 'mouse' && dy > 100 && dy > Math.abs(dx) * 1.5) self.closeLb();
          }
        }
        g = pts.size ? snap(false, true) : null;
        if (!pts.size && z.s < 1.02 && z.s !== 1) self.lbZoomTo(1, null, true);
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
      stage.addEventListener('wheel', function (e) {
        e.preventDefault(); self.lbHint(false);
        var s = z.s * Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0025));
        self.lbZoomTo(s < 1.02 ? 1 : s, self.lbRel(e.clientX, e.clientY), false);
      }, { passive: false });
    }
    // point relative to the image's un-zoomed centre
    lbRel(cx, cy) {
      var r = this.lbStage.getBoundingClientRect(), i = this.lbImg;
      return { x: cx - r.left - i.offsetLeft - i.offsetWidth / 2, y: cy - r.top - i.offsetTop - i.offsetHeight / 2 };
    }
    lbCenter() { var r = this.lbStage.getBoundingClientRect(); return this.lbRel(r.left + r.width / 2, r.top + r.height / 2); }
    lbMax() { var i = this.lbImg, w = i.offsetWidth || 1; return Math.min(6, Math.max(3, (i.naturalWidth || 0) / w * 1.25)); }
    lbZoomTo(s, q, anim) {
      var z = this.z; s = Math.max(1, Math.min(this.lbMax(), s)); q = q || { x: 0, y: 0 };
      z.x = q.x - (q.x - z.x) * s / z.s; z.y = q.y - (q.y - z.y) * s / z.s; z.s = s;
      this.lbApply(anim);
    }
    lbApply(anim) {
      var z = this.z, img = this.lbImg, st = this.lbStage;
      var w = img.offsetWidth, h = img.offsetHeight, W = st.clientWidth, H = st.clientHeight;
      var cx = img.offsetLeft + w / 2, cy = img.offsetTop + h / 2, sw = w * z.s, sh = h * z.s;
      z.x = sw <= W ? 0 : Math.min(sw / 2 - cx, Math.max(W - cx - sw / 2, z.x));
      z.y = sh <= H ? 0 : Math.min(sh / 2 - cy, Math.max(H - cy - sh / 2, z.y));
      img.style.transition = anim && !reduce ? 'transform .28s cubic-bezier(.2,.7,.2,1)' : 'none';
      img.style.transform = z.s === 1 && !z.x && !z.y ? '' : 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
      var zoomed = z.s > 1.01;
      this.lb.classList.toggle('is-zoomed', zoomed);
      this.lbOut.disabled = !zoomed;
      this.lbIn.disabled = z.s >= this.lbMax() - 0.01;
    }
    lbHint(on) {
      var el = this.lbHintEl; if (!el) return;
      clearTimeout(this.lbHintT);
      if (on) {
        el.textContent = finePointer() ? 'Click or scroll to zoom' : 'Pinch or double-tap to zoom';
        el.classList.add('is-on');
        var self = this; this.lbHintT = setTimeout(function () { el.classList.remove('is-on'); }, 3200);
      } else el.classList.remove('is-on');
    }
    openLb(slideIndex) {
      if (!this.zoomList || !this.zoomList.length) return;
      if (!this.lb) this.buildLb();
      var pos = this.zoomList.indexOf(slideIndex); if (pos < 0) pos = 0;
      this.prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      if (this.lb.showModal) this.lb.showModal(); else this.lb.setAttribute('open', '');
      window.addEventListener('resize', this.lbOnResize);
      this.lbShow(pos);
      var many = this.zoomList.length > 1;
      this.lb.querySelector('[data-lb-prev]').hidden = !many; this.lb.querySelector('[data-lb-next]').hidden = !many;
      this.lb.querySelector('[data-lb-close]').focus({ preventScroll: true });
      this.lbHint(true);
    }
    closeLb() { if (!this.lb) return; if (this.lb.close) this.lb.close(); else { this.lb.removeAttribute('open'); document.documentElement.style.overflow = this.prevOverflow || ''; } }
    lbShow(pos) {
      var self = this, n = this.zoomList.length; pos = (pos + n) % n; this.lbPos = pos;
      var s = this.slides[this.zoomList[pos]], hi = s.dataset.zoomSrc, low = s.querySelector('img');
      this.z.s = 1; this.z.x = 0; this.z.y = 0;
      // show the already-loaded gallery photo at once, swap in the sharp 2400px file when ready
      this.lbImg.src = (low && low.complete && low.currentSrc) || hi; this.lbImg.alt = s.dataset.zoomAlt || '';
      if (this.lbImg.src !== hi) { var pre = new Image(); pre.onload = function () { if (self.lbPos === pos) self.lbImg.src = hi; }; pre.src = hi; }
      this.lbApply(false);
      this.lbCount.textContent = n > 1 ? (pos + 1) + ' / ' + n : '';
      var nx = this.slides[this.zoomList[(pos + 1) % n]]; if (nx && n > 1) (new Image()).src = nx.dataset.zoomSrc;
    }
    lbStep(dir) { this.lbShow(this.lbPos + dir); }
    show(mediaId) {
      for (var i = 0; i < this.slides.length; i++) if (String(this.slides[i].dataset.mediaId) === String(mediaId)) return this.goTo(i);
    }
    sync() {
      var w = this.track.clientWidth || 1;
      var i = Math.round(Math.abs(this.track.scrollLeft) / w);
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      this.thumbs.forEach(function (b, n) { b.setAttribute('aria-current', n === this.index ? 'true' : 'false'); }, this);
      if (this.count) this.count.textContent = (this.index + 1) + ' / ' + this.slides.length;
      var t = this.thumbs[this.index];
      if (t && t.parentElement) { var p = t.parentElement; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'auto' }); }
    }
  }

  /* ===================================================================
     <fm-product> — options → variant, bundle tiers, ATC state, size finder
     =================================================================== */
  class FmProduct extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('script[data-fm-variants]');
      if (!data) return;
      try { this.variants = JSON.parse(data.textContent); } catch (e) { this.variants = []; }
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('input[name="id"]');
      this.qtyInput = this.querySelector('input[name="quantity"]');
      this.atc = this.querySelector('[data-fm-atc]');
      this.atcLabel = this.querySelector('[data-fm-atc-label]');
      this.atcPrice = this.querySelector('[data-fm-atc-price]');
      this.priceNow = this.querySelector('[data-fm-price]');
      this.priceWas = this.querySelector('[data-fm-compare]');
      this.msg = this.querySelector('[data-fm-msg]');
      this.opts = qa('[data-fm-option]', this);
      this.tiers = qa('[data-fm-tier]', this);
      this.requireChoice = this.dataset.requireChoice === 'true';
      this.packNote = this.querySelector('[data-fm-packnote]');
      var self = this;
      this.colorIdx = -1; this.sizeIdx = -1;
      this.opts.forEach(function (f, i) {
        if (f.dataset.isColor === 'true' && self.colorIdx < 0) self.colorIdx = i;
        if (f.dataset.isSize === 'true' && self.sizeIdx < 0) self.sizeIdx = i;
      });

      this.opts.forEach(function (f) {
        qa('input[type=radio]', f).forEach(function (r) { r.addEventListener('change', function () { f.classList.remove('is-nudge'); self.update(true); }); });
      });
      this.tiers.forEach(function (t) { qa('input', t).forEach(function (r) { r.addEventListener('change', function () { self.update(false); }); }); });
      if (this.form) this.form.addEventListener('submit', function (ev) {
        if (!self.variant) { ev.preventDefault(); self.nudge(); return; }
        if (self.variant && !self.variant.available) { ev.preventDefault(); return; }
        if (self.variant.items) { ev.preventDefault(); self.addPack(self.variant, self.tier()); return; }
        if (!self.form.querySelector('input[name="return_to"]')) {
          ev.preventDefault();
          self.addItems([{ id: self.variant.id, quantity: parseInt(self.qtyInput && self.qtyInput.value, 10) || 1 }]);
          return;
        }
        if (self.atc) { self.atc.setAttribute('aria-busy', 'true'); }
      });
      this.initDialog();
      this.initMix();
      this.update(false);
    }

    selected() {
      return this.opts.map(function (f) { var r = f.querySelector('input:checked'); return r ? r.value : null; });
    }
    findVariant(sel) {
      if (!this.opts.length) return this.variants[0] || null;
      if (sel.some(function (v) { return v === null; })) return null;
      return this.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
    }
    tier() {
      var t = this.tiers.filter(function (x) { return x.querySelector('input').checked; })[0];
      return t || null;
    }
    nudge() {
      if (this.mix) { this.mixNudge(); return; }
      var missing = this.opts.filter(function (f) { return !f.hidden && !f.querySelector('input:checked'); })[0];
      if (!missing) return;
      missing.classList.remove('is-nudge'); void missing.offsetWidth; missing.classList.add('is-nudge');
      if (this.msg) this.msg.textContent = this.dataset.msgSelect || '';
      var top = missing.getBoundingClientRect().top;
      if (top < 80 || top > window.innerHeight - 120) missing.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
    /* fixed-assortment packs: tier carries data-comp='[{"c":"Black","q":2},…]' */
    compOf(t) {
      if (!t || !t.dataset.comp || this.colorIdx < 0) return null;
      try { var c = JSON.parse(t.dataset.comp); return c.length ? c : null; } catch (e) { return null; }
    }
    colorVariant(color, size) {
      var ci = this.colorIdx, si = this.sizeIdx, lc = String(color).toLowerCase(), last = lc.split(' ').pop();
      var inSize = function (v) { return si < 0 || v.options[si] === size; };
      return this.variants.filter(function (v) { return String(v.options[ci]).toLowerCase() === lc && inSize(v); })[0] ||
        this.variants.filter(function (v) { return String(v.options[ci]).toLowerCase().split(' ').pop() === last && inSize(v); })[0] || null;
    }
    packVariant(comp, size) {
      if (this.sizeIdx >= 0 && size === null) return null;
      var items = [], ok = true, self = this;
      comp.forEach(function (c) {
        var m = self.colorVariant(c.c, size);
        if (!m) { ok = false; if (window.console) console.warn('[formare] pack colour not found in variants:', c.c); return; }
        if (!m.available) ok = false;
        items.push({ id: m.id, quantity: c.q });
      });
      var first = items[0] ? items[0].id : (this.variants[0] && this.variants[0].id);
      return { id: first, title: size || '', options: [], available: ok && items.length > 0, items: items, media: 0 };
    }
    /* low-stock notice from real Shopify inventory (variants carry "inv" only when stock is tracked) */
    stock(v, tier, comp) {
      var box = this.querySelector('[data-fm-stock]'); if (!box) return;
      var n = null, self = this, txt = '';
      if (v && v.available) {
        if (comp && v.items) {
          v.items.forEach(function (it) {
            var m = self.variants.filter(function (x) { return x.id === it.id; })[0];
            if (!m || m.inv === null || m.inv === undefined) return;
            var packs = Math.floor(m.inv / it.quantity);
            n = n === null ? packs : Math.min(n, packs);
          });
          txt = (box.dataset.textPack || '').replace('{count}', n).replace('{pack}', (tier && tier.dataset.label) || '').replace('{size}', v.title || '');
        } else if (v.inv !== null && v.inv !== undefined) {
          n = v.inv;
          txt = (box.dataset.text || '').replace('{count}', n).replace('{variant}', v.title || '');
        }
      }
      var thr = parseInt(box.dataset.threshold, 10) || 5;
      var low = n !== null && n > 0 && n <= thr;
      var always = box.dataset.mode === 'always';
      box.hidden = !(low || always);
      box.querySelector('[data-fm-stock-title]').textContent = box.dataset.title || '';
      box.querySelector('[data-fm-stock-text]').textContent = low ? txt : (box.dataset.manual || '');
    }

    /* ---- "Customise colours & sizes": a link under a fixed pack. Opens the shopper's own mix; what they pick goes to the cart
       exactly as chosen. Pack price still comes from the store's quantity discount (exactly 6 / 12 pieces).
       Small packs: one row per piece (#, colour, size). Big packs: one line per colour/size with a quantity (keeps 12 short). ---- */
    initMix() {
      var self = this; this.mixes = []; this.mix = null;
      if (this.colorIdx < 0) return;
      qa('[data-fm-mix]', this).forEach(function (el) {
        var p = { el: el, tier: el.dataset.tier, mode: el.dataset.mode === 'lines' ? 'lines' : 'rows', open: false, lines: [], need: 0 };
        p.toggle = el.querySelector('[data-fm-mix-toggle]'); p.tlabel = el.querySelector('[data-fm-mix-toggle-label]');
        p.body = el.querySelector('[data-fm-mix-body]'); p.rows = el.querySelector('[data-fm-mix-rows]'); p.count = el.querySelector('[data-fm-mix-count]');
        p.hint = el.querySelector('[data-fm-mix-hint]'); p.cols = el.querySelector('[data-fm-mix-cols]'); p.add = el.querySelector('[data-fm-mix-add]');
        try { p.colors = JSON.parse(el.dataset.colors) || []; } catch (e) { p.colors = []; }
        try { p.sizes = JSON.parse(el.dataset.sizes) || []; } catch (e) { p.sizes = []; }
        if (!p.colors.length) return;
        p.toggle.addEventListener('click', function () { self.mixToggle(p); });
        p.rows.addEventListener('change', function (e) {
          var t = e.target, row = t.closest('[data-i]'); if (!row) return;
          var l = p.lines[+row.dataset.i]; if (!l) return;
          t.classList.remove('is-nudge');
          if (t.dataset.f === 'c') l.c = t.value;
          else if (p.mode === 'lines') l.s = t.value;
          else { l.s = t.value; p.lines.forEach(function (o) { if (!o.s) o.s = t.value; }); }   // rows still without a size follow the first size picked
          self.mixSync(p); self.update(false);
        });
        p.rows.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b || p.mode !== 'lines') return;
          var row = b.closest('[data-i]'), i = row ? +row.dataset.i : -1, l = p.lines[i]; if (!l) return;
          if (b.hasAttribute('data-inc')) { if (self.mixTotal(p) < p.need) l.q++; }
          else if (b.hasAttribute('data-dec')) { if (l.q > 1) l.q--; }
          else if (b.hasAttribute('data-del')) { if (p.lines.length > 1) { p.lines.splice(i, 1); self.mixBuild(p); } }
          self.mixSync(p); self.update(false);
        });
        if (p.add) p.add.addEventListener('click', function () {
          if (self.mixTotal(p) >= p.need) return;
          var last = p.lines[p.lines.length - 1], used = p.lines.map(function (l) { return l.c; });
          var pick = p.colors.filter(function (c) { return used.indexOf(c.n) < 0 && self.mixColorOk(p, c.n, last && last.s); })[0] ||
            p.colors.filter(function (c) { return self.mixColorOk(p, c.n, last && last.s); })[0] || p.colors[0];
          p.lines.push({ c: pick.n, s: last ? last.s : '', q: 1 });
          self.mixBuild(p); self.update(false);
          var sel = p.rows.querySelectorAll('select[data-f="c"]'); if (sel.length) sel[sel.length - 1].focus();
        });
        self.mixes.push(p);
      });
    }
    mixFor(tier) {
      if (!tier || tier.dataset.mix !== '1') return null;
      var v = tier.querySelector('input').value;
      return this.mixes.filter(function (p) { return p.tier === v; })[0] || null;
    }
    mixTotal(p) { return p.mode === 'lines' ? p.lines.reduce(function (n, l) { return n + l.q; }, 0) : p.lines.length; }
    mixColorOk(p, color, size) {
      var self = this;
      if (this.sizeIdx >= 0 && !size) return p.sizes.some(function (z) { var v = self.colorVariant(color, z); return v && v.available; });
      var v = this.colorVariant(color, this.sizeIdx >= 0 ? size : null); return !!(v && v.available);
    }
    mixToggle(p) {
      var d = p.el.dataset;
      if (p.open) { p.open = false; p.lines = []; }
      else {
        var comp = this.compOf(this.tier()); if (!comp) return;
        var sz = this.sizeIdx >= 0 ? (this.selected()[this.sizeIdx] || '') : '';
        p.lines = []; p.need = comp.reduce(function (n, c) { return n + c.q; }, 0);
        comp.forEach(function (c) {   // starts from the standard set
          if (p.mode === 'lines') p.lines.push({ c: c.c, s: sz, q: c.q });
          else for (var k = 0; k < c.q; k++) p.lines.push({ c: c.c, s: sz });
        });
        p.open = true;
      }
      p.body.hidden = !p.open; p.el.classList.toggle('is-open', p.open); p.toggle.setAttribute('aria-expanded', p.open ? 'true' : 'false');
      p.tlabel.textContent = p.open ? (d.closeLabel || '') : (d.openLabel || '');
      if (p.open) this.mixBuild(p);
      this.update(false);
    }
    mixBuild(p) {
      var d = p.el.dataset, hasSize = this.sizeIdx >= 0, lines = p.mode === 'lines';
      var mk = function (tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt !== undefined) n.textContent = txt; return n; };
      p.hint.textContent = (lines ? d.hintLines : d.hintRows) || ''; p.hint.hidden = !p.hint.textContent;
      p.cols.textContent = '';
      if (!lines) p.cols.appendChild(mk('span'));
      p.cols.appendChild(mk('span', '', d.lblColour || 'Colour'));
      if (hasSize) p.cols.appendChild(mk('span', '', d.lblSize || 'Size'));
      if (lines) { p.cols.appendChild(mk('span', 'fm-mix__qh', d.lblQty || 'Qty')); p.cols.appendChild(mk('span')); }
      p.cols.classList.toggle('fm-mix__cols--lines', lines);
      if (p.add) p.add.hidden = !lines;
      p.rows.textContent = '';
      p.lines.forEach(function (l, i) {
        var row = mk('div', 'fm-mix__row' + (lines ? ' fm-mix__row--line' : '')); row.dataset.i = i;
        if (!lines) row.appendChild(mk('span', 'fm-mix__no', '#' + (i + 1)));
        var cw = mk('span', 'fm-mix__sel fm-mix__sel--c'), dot = mk('span', 'fm-comp__dot fm-mix__dot'); dot.setAttribute('aria-hidden', 'true');
        var cs = mk('select'); cs.dataset.f = 'c'; cs.setAttribute('aria-label', (d.lblColour || 'Colour') + ' #' + (i + 1));
        p.colors.forEach(function (c) { var o = mk('option', '', c.n); o.value = c.n; cs.appendChild(o); });
        cw.appendChild(dot); cw.appendChild(cs); row.appendChild(cw);
        if (hasSize) {
          var sw = mk('span', 'fm-mix__sel'), ss = mk('select'); ss.dataset.f = 's'; ss.setAttribute('aria-label', (d.lblSize || 'Size') + ' #' + (i + 1));
          var ph = mk('option', '', '–'); ph.value = ''; ss.appendChild(ph);
          p.sizes.forEach(function (z) { var o = mk('option', '', z); o.value = z; ss.appendChild(o); });
          sw.appendChild(ss); row.appendChild(sw);
        }
        if (lines) {
          var q = mk('span', 'fm-mix__qty'); q.setAttribute('role', 'group'); q.setAttribute('aria-label', (d.lblQty || 'Qty') + ' #' + (i + 1));
          var dec = mk('button', '', '−'), n = mk('span', 'fm-mix__n'), inc = mk('button', '', '+');
          dec.type = 'button'; inc.type = 'button'; dec.setAttribute('data-dec', ''); inc.setAttribute('data-inc', '');
          dec.setAttribute('aria-label', '− 1'); inc.setAttribute('aria-label', '+ 1');
          q.appendChild(dec); q.appendChild(n); q.appendChild(inc); row.appendChild(q);
          var del = mk('button', 'fm-mix__del', '×'); del.type = 'button'; del.setAttribute('data-del', ''); del.setAttribute('aria-label', (d.lblRemove || 'Remove') + ' #' + (i + 1));
          row.appendChild(del);
        }
        p.rows.appendChild(row);
      });
      this.mixSync(p);
    }
    /* reflect state in the rows without rebuilding them (keeps focus) */
    mixSync(p) {
      var self = this, d = p.el.dataset, sold = d.sold || 'sold out', lines = p.mode === 'lines', ready = 0, total = this.mixTotal(p), full = total >= p.need;
      qa('.fm-mix__row', p.rows).forEach(function (row, i) {
        var l = p.lines[i]; if (!l) return;
        var cs = row.querySelector('select[data-f="c"]'), ss = row.querySelector('select[data-f="s"]');
        qa('option', cs).forEach(function (o) {
          var ok = self.mixColorOk(p, o.value, l.s);
          o.disabled = !ok && o.value !== l.c; o.textContent = o.value + (ok ? '' : ' — ' + sold);
        });
        cs.value = l.c;
        var col = p.colors.filter(function (c) { return c.n === l.c; })[0];
        if (col) row.querySelector('.fm-mix__dot').style.setProperty('--sw', col.sw);
        if (ss) {
          qa('option', ss).forEach(function (o) {
            if (!o.value) return;
            var v = self.colorVariant(l.c, o.value), ok = !!(v && v.available);
            o.disabled = !ok && o.value !== l.s; o.textContent = o.value + (ok ? '' : ' — ' + sold);
          });
          ss.value = l.s || '';
        }
        if (self.sizeIdx < 0 || l.s) ready++;
        if (lines) {
          row.querySelector('.fm-mix__n').textContent = l.q;
          row.querySelector('[data-dec]').disabled = l.q <= 1;
          row.querySelector('[data-inc]').disabled = full;
          row.querySelector('[data-del]').style.visibility = p.lines.length < 2 ? 'hidden' : '';
        }
      });
      var done = lines ? (full && ready >= p.lines.length) : (ready >= p.lines.length);
      if (lines && p.add) p.add.hidden = full;
      var txt = lines ? (full ? (ready >= p.lines.length ? d.doneText : d.totalText.replace('{n}', total).replace('{need}', p.need)) : d.totalText.replace('{n}', total).replace('{need}', p.need))
                      : (done ? d.doneText : (d.countText || '').replace('{n}', ready).replace('{need}', p.lines.length));
      p.count.textContent = txt || ''; p.count.classList.toggle('is-done', done);
    }
    /* cart lines for the custom set; null until the total is complete and every piece has a size */
    mixVariant(p) {
      var self = this, items = [], ok = true, miss = false, sizes = [], lines = p.mode === 'lines';
      p.lines.forEach(function (l) {
        if (self.sizeIdx >= 0 && !l.s) { miss = true; return; }
        var mv = self.colorVariant(l.c, self.sizeIdx >= 0 ? l.s : null), q = lines ? l.q : 1;
        if (!mv) { ok = false; return; }
        if (!mv.available) ok = false;
        var ex = items.filter(function (x) { return x.id === mv.id; })[0];
        if (ex) ex.quantity += q; else { ex = { id: mv.id, quantity: q }; items.push(ex); }
        if (l.s && sizes.indexOf(l.s) < 0) sizes.push(l.s);
        if (mv.inv !== null && mv.inv !== undefined && ex.quantity > mv.inv) ok = false;
      });
      if (miss || this.mixTotal(p) !== p.need) return null;
      return { id: items[0] ? items[0].id : this.variants[0].id, title: sizes.join(', '), options: [], available: ok && items.length > 0, items: items, media: 0, custom: true };
    }
    mixNudge() {
      var p = this.mix, d = this.dataset, left = p.need - this.mixTotal(p), hit = null, msg = '';
      if (left > 0 && p.mode === 'lines') {
        msg = (d.msgTotal || '').replace('{left}', left).replace('{need}', p.need);
        hit = p.add && !p.add.hidden ? p.add : null;
      } else {
        hit = qa('select[data-f="s"]', p.rows).filter(function (x) { return !x.value; })[0] || null;
        msg = d.msgMix || d.msgSelect || '';
      }
      if (this.msg) this.msg.textContent = msg;
      var target = hit || p.el;
      if (hit) { hit.classList.remove('is-nudge'); void hit.offsetWidth; hit.classList.add('is-nudge'); }
      var top = target.getBoundingClientRect().top;
      if (top < 80 || top > window.innerHeight - 120) target.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
    /* the link shows under the selected pack only; the custom mix replaces the plain size picker while open */
    mixApply(tier) {
      var act = this.mixFor(tier);
      this.mixes.forEach(function (p) { p.el.hidden = p !== act; });
      this.mix = act && act.open ? act : null;
    }
    addPack(v, tier) {
      var props = { _bundle: (tier && tier.dataset.label) || 'Bundle' };
      if (v.custom) props._mix = 'custom';
      this.addItems(v.items.map(function (i) { return { id: i.id, quantity: i.quantity, properties: props }; }));
    }
    /* Adds lines with the Cart API. "Checkout" mode → /checkout. "Cart" mode → opens the theme's cart drawer /
       notification (Dawn and most OS 2.0 themes) and stays on the page; otherwise goes to /cart. */
    addItems(items) {
      var self = this, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var ret = this.form.querySelector('input[name="return_to"]');
      var cart = ret ? null : (document.querySelector('cart-notification') || document.querySelector('cart-drawer'));
      var canRender = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
      var body = { items: items };
      if (canRender) { body.sections = cart.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = location.pathname; }
      if (this.atc) { this.atc.setAttribute('aria-busy', 'true'); this.atc.disabled = true; }
      var done = function () { if (self.atc) { self.atc.removeAttribute('aria-busy'); self.atc.disabled = false; } };
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (res) {
          if (ret && ret.value) { location.href = ret.value; return; }
          if (canRender && res && res.sections) {
            try {
              if (res.items && res.items[0]) { res.key = res.items[0].key; res.id = res.items[0].variant_id; }
              cart.classList.remove('is-empty');
              cart.renderContents(res);
              done();
              document.dispatchEvent(new CustomEvent('fm:cart-added', { detail: { items: items, response: res } }));
              return;
            } catch (e) { /* fall through to the cart page */ }
          }
          location.href = root + 'cart';
        })
        .catch(function () {
          done();
          if (self.msg) self.msg.textContent = self.dataset.msgError || '';
        });
    }

    update(fromOption) {
      var tier = this.tier(), comp = this.compOf(tier), sel = this.selected(), v;
      if (this.mixes) this.mixApply(tier);
      var custom = !!this.mix;
      if (custom) v = this.mixVariant(this.mix);
      else if (comp) { sel[this.colorIdx] = '__pack__'; v = this.packVariant(comp, this.sizeIdx >= 0 ? sel[this.sizeIdx] : null); }
      else v = this.findVariant(sel);
      this.variant = v;
      var qty = (comp || custom) ? 1 : (tier ? parseInt(tier.dataset.qty, 10) : 1);
      if (this.qtyInput) this.qtyInput.value = qty;

      // sold-out hints for the current combination (pills stay selectable so the shopper can see what's gone)
      var self = this;
      this.opts.forEach(function (f, i) {
        f.hidden = custom || (!!comp && i === self.colorIdx);
        qa('.fm-pill', f).forEach(function (lbl) {
          var r = lbl.querySelector('input'), ok;
          if (custom) { ok = true; }
          else if (comp) {
            ok = i !== self.sizeIdx || comp.every(function (c) { var m = self.colorVariant(c.c, r.value); return m && m.available; });
          } else {
            ok = self.variants.some(function (x) {
              return x.options[i] === r.value && x.available && sel.every(function (s2, j) { return j === i || s2 === null || x.options[j] === s2; });
            });
          }
          lbl.classList.toggle('is-soldout', !ok);
        });
      });
      if (this.packNote) {
        var pt = comp && this.dataset.packNote ? this.dataset.packNote.replace('{items}', tier.dataset.packText || '') : '';
        this.packNote.textContent = pt; this.packNote.hidden = !pt;
      }
      // wallet buttons would only buy the first line of a pack
      qa('.shopify-payment-button', this).forEach(function (b) { b.hidden = !!comp || custom; });

      // legend value text
      this.opts.forEach(function (f, i) {
        var out = f.querySelector('[data-fm-opt-val]'); if (out) out.textContent = sel[i] === '__pack__' ? '' : (sel[i] || '');
      });

      // prices (strings are pre-rendered by Liquid per variant so they always match the store's money format)
      var k = v ? v.id : (this.variants[0] && this.variants[0].id);
      this.tiers.forEach(function (t) {
        var a = t.querySelector('[data-fm-tier-total]'), b = t.querySelector('[data-fm-tier-was]'), c = t.querySelector('[data-fm-tier-each]');
        if (a && t.dataset['t' + k]) a.textContent = t.dataset['t' + k];
        if (b && t.dataset['c' + k]) b.textContent = t.dataset['c' + k];
        if (c && t.dataset['u' + k]) c.textContent = t.dataset['u' + k];
      });
      if (v && this.idInput) this.idInput.value = v.id;
      if (this.priceNow) {
        if ((comp || custom) && tier.dataset['t' + k]) {
          this.priceNow.textContent = tier.dataset['t' + k];
          if (this.priceWas) { var cw = tier.dataset['c' + k]; this.priceWas.textContent = cw || ''; this.priceWas.hidden = !cw; }
        } else {
          if (this.priceNow.dataset['p' + k]) this.priceNow.textContent = this.priceNow.dataset['p' + k];
          if (this.priceWas) { var was = this.priceWas.dataset['p' + k]; this.priceWas.textContent = was || ''; this.priceWas.hidden = !was; }
        }
      }
      if (v && this.atcPrice && tier && tier.dataset['t' + v.id]) this.atcPrice.textContent = tier.dataset['t' + v.id];

      // button state
      if (this.atc && this.atcLabel) {
        this.atc.removeAttribute('aria-busy');
        if (!v) { this.atcLabel.textContent = custom ? (this.dataset.labelMix || this.dataset.labelSelect) : this.dataset.labelSelect; this.atc.disabled = false; if (this.atcPrice) this.atcPrice.textContent = ''; }
        else if (!v.available) { this.atcLabel.textContent = this.dataset.labelSoldout; this.atc.disabled = true; if (this.atcPrice) this.atcPrice.textContent = ''; }
        else { this.atcLabel.textContent = this.dataset.labelAdd; this.atc.disabled = false; }
      }
      if (this.msg && (v || custom)) this.msg.textContent = '';

      // url + gallery
      if (v && !comp && !custom && fromOption && !document.documentElement.classList.contains('shopify-design-mode')) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      }
      if (v && !comp && !custom && fromOption && v.media) { var g = document.querySelector('fm-gallery'); if (g && g.show) g.show(v.media); }

      this.stock(custom ? null : v, tier, comp);
      document.dispatchEvent(new CustomEvent('fm:variant', { detail: { variant: v, qty: qty, tier: tier, comp: comp, product: this, label: !v && custom ? (this.dataset.labelMix || '') : '' } }));
    }

    /* ---- size finder ---- */
    initDialog() {
      var dlg = this.querySelector('dialog.fm-dialog'); if (!dlg) return;
      var self = this, openers = qa('[data-fm-size-open]', this);
      openers.forEach(function (b) { b.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }); });
      qa('[data-fm-size-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      var wIn = dlg.querySelector('[data-fm-waist]'), hIn = dlg.querySelector('[data-fm-hips]');
      var go = dlg.querySelector('[data-fm-find]'), out = dlg.querySelector('[data-fm-result]');
      var rows = qa('tr[data-size]', dlg);
      var show = function (html, size) {
        out.classList.add('is-on'); out.innerHTML = '';
        var span = document.createElement('span'); span.textContent = html; out.appendChild(span);
        rows.forEach(function (r) { r.classList.toggle('is-match', !!size && r.dataset.size === size); });
        if (size) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'fm-btn'; b.textContent = out.dataset.pick + ' ' + size;
          b.addEventListener('click', function () { self.pickSize(size); dlg.close(); });
          out.appendChild(b);
        }
      };
      if (go) go.addEventListener('click', function () {
        var w = parseFloat(wIn.value), h = parseFloat(hIn.value);
        if (!(w > 0) || !(h > 0)) { show(out.dataset.need); return; }
        var hit = null;
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i];
          if (w <= parseFloat(r.dataset.waist) && h <= parseFloat(r.dataset.hips)) { hit = r; break; }
        }
        if (!hit) { show(out.dataset.over); return; }
        show(out.dataset.is.replace('{size}', hit.dataset.size), hit.dataset.size);
      });
    }
    pickSize(size) {
      var done = false;
      this.opts.forEach(function (f) {
        if (done || f.dataset.isSize !== 'true') return;
        qa('input[type=radio]', f).forEach(function (r) {
          if (r.value.toLowerCase() === size.toLowerCase() && !r.disabled) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); done = true; }
        });
      });
    }
  }

  /* ===================================================================
     <fm-sticky> — bottom bar, appears once the main ATC leaves the screen
     =================================================================== */
  class FmSticky extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-fm-sticky-btn]');
      this.label = this.querySelector('[data-fm-sticky-label]');
      this.sub = this.querySelector('[data-fm-sticky-sub]');
      this.price = this.querySelector('[data-fm-sticky-price]');
      var self = this;
      this.onVariant = function (e) { self.render(e.detail); };
      document.addEventListener('fm:variant', this.onVariant);
      var main = document.querySelector('fm-product [data-fm-atc]');
      this.main = main;
      var host = main && main.closest('fm-product');
      if (host && host.variant !== undefined && typeof host.tier === 'function') this.render({ variant: host.variant, tier: host.tier(), product: host });
      if (this.btn) this.btn.addEventListener('click', function () {
        var p = main && main.closest('fm-product');
        if (!p) return;
        if (!p.variant) { p.nudge(); var o = p.mix ? p.mix.el : p.querySelector('[data-fm-option]'); if (o) o.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); return; }
        if (p.form.requestSubmit) p.form.requestSubmit(); else p.form.submit();
      });
      if (main && 'IntersectionObserver' in window) {
        this.visible = true;
        this.io = new IntersectionObserver(function (es) { self.visible = es[0].isIntersecting; self.toggle(); }, { rootMargin: '0px 0px -10% 0px' });
        this.io.observe(main);
        // hide again while the closing CTA / footer is on screen
        var end = document.querySelector('[data-fm-sticky-end]');
        if (end) { this.endIO = new IntersectionObserver(function (es) { self.atEnd = es[0].isIntersecting; self.toggle(); }); this.endIO.observe(end); }
        // the observers only fire on changes; if the button starts below the fold nothing would ever re-check, so also re-check while scrolling
        var raf = 0;
        this.onScroll = function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; self.toggle(); }); };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      } else { this.classList.add('is-on'); }
      // keep the bar on the real bottom edge while the browser toolbar slides in/out (Chrome iOS left a gap under it)
      var vv = window.visualViewport;
      if (vv) {
        this.classList.add('is-vv');
        this.onVV = function () {
          if (Math.abs((vv.scale || 1) - 1) > 0.01) { self.style.removeProperty('--fm-vv-bottom'); return; } // pinch-zoomed: leave it on the layout bottom
          self.style.setProperty('--fm-vv-bottom', Math.round(vv.offsetTop + vv.height) + 'px');
        };
        this.onVV();
        vv.addEventListener('resize', this.onVV);
        vv.addEventListener('scroll', this.onVV);
        window.addEventListener('scroll', this.onVV, { passive: true });
      }
    }
    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onVV) { var vv = window.visualViewport; if (vv) { vv.removeEventListener('resize', this.onVV); vv.removeEventListener('scroll', this.onVV); } window.removeEventListener('scroll', this.onVV); }
      document.removeEventListener('fm:variant', this.onVariant); if (this.io) this.io.disconnect(); if (this.endIO) this.endIO.disconnect();
    }
    toggle() {
      var scrolledPast = this.main && this.main.getBoundingClientRect().top < 0;
      this.classList.toggle('is-on', !this.visible && !this.atEnd && scrolledPast);
    }
    render(d) {
      if (!d || !this.label) return;
      var v = d.variant;
      if (!v) { this.label.textContent = d.label || this.dataset.labelSelect; if (this.sub) this.sub.textContent = ''; if (this.price) this.price.textContent = ''; this.btn.disabled = false; return; }
      this.btn.disabled = !v.available;
      this.label.textContent = v.available ? this.dataset.labelAdd : this.dataset.labelSoldout;
      var tt = d.tier, vt = v.title && v.title !== 'Default Title' ? v.title : '';
      if (this.sub) this.sub.textContent = v.items && tt ? (tt.dataset.label + (vt ? ' · ' + vt : '')) : vt;
      var t = d.tier, p = d.product;
      if (this.price) this.price.textContent = v.available && t && t.dataset['t' + v.id] ? t.dataset['t' + v.id] : '';
    }
  }


  /* ===================================================================
     <fm-countdown> — counts down to a real end time (fixed date, or today's order cut-off in the store's time zone).
     Never restarts per visit; hides itself when there is nothing left to count.
     =================================================================== */
  class FmCountdown extends HTMLElement {
    connectedCallback() {
      this.out = this.querySelector('[data-fm-time]');
      var off = parseFloat(this.dataset.offset || '0') || 0, sign = off < 0 ? '-' : '+', a = Math.abs(off);
      this.tz = sign + String(Math.floor(a)).padStart(2, '0') + ':' + String(Math.round((a % 1) * 60)).padStart(2, '0');
      this.offMs = off * 3600000;
      var self = this; this.tick(); this.t = setInterval(function () { self.tick(); }, 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
    target(now) {
      if (this.dataset.mode === 'daily') {
        var h = parseInt(this.dataset.cutoff, 10) || 0;
        var local = new Date(now + this.offMs);                     // wall clock in the store's zone, read via UTC getters
        var cut = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), h) - this.offMs;
        if (cut <= now) cut += 86400000;
        return cut;
      }
      // accepts 2026-11-30 / 2026.11.30 / 2026/11/30, time 23:59 or 9:00 (blank -> 23:59)
      var raw = (this.dataset.end || '').replace(/\s+/g, '');
      var m = raw.match(/^(\d{4})[-.\/](\d{1,2})[-.\/](\d{1,2})\.?T?(\d{1,2})?[:.]?(\d{2})?$/);
      if (!m) return NaN;
      var p2 = function (x) { return String(x).padStart(2, '0'); };
      var hh = m[4] !== undefined ? m[4] : '23', mm = m[5] !== undefined ? m[5] : '59';
      return Date.parse(m[1] + '-' + p2(m[2]) + '-' + p2(m[3]) + 'T' + p2(hh) + ':' + mm + ':00' + this.tz);
    }
    tick() {
      var now = Date.now(), end = this.target(now), left = end - now;
      if (!(left > 0)) {
        clearInterval(this.t);
        if (window.Shopify && Shopify.designMode) {   // theme editor only: say why it's hidden on the live store
          this.hidden = false; this.classList.add('is-warn');
          this.out.textContent = isNaN(end) ? 'Check the end date (YYYY-MM-DD)' : 'Offer has ended - hidden on the store';
          return;
        }
        this.hidden = true; return;
      }
      var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var p2 = function (n) { return String(n).padStart(2, '0'); };
      this.out.textContent = (d > 0 ? d + 'd ' : '') + p2(h) + ' : ' + p2(m) + ' : ' + p2(sec);
      this.hidden = false;
    }
  }

  var defs = { 'fm-countdown': FmCountdown, 'fm-sticky': FmSticky, 'fm-clip': FmClip, 'fm-slider': FmSlider, 'fm-compare': FmCompare, 'fm-gallery': FmGallery, 'fm-product': FmProduct };
  Object.keys(defs).forEach(function (n) { if (!customElements.get(n)) customElements.define(n, defs[n]); });
})();